import { useEffect, useState } from 'react';
const VALID_MODES = ['light', 'dark', 'system'];
export function isValidThemeMode(value) {
    return typeof value === 'string' && VALID_MODES.includes(value);
}
function getSystemTheme() {
    if (typeof window === 'undefined')
        return 'light';
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}
function resolveTheme(mode) {
    if (mode === 'system')
        return getSystemTheme();
    return mode;
}
export function useThemeEffect({ mode }) {
    const [resolvedTheme, setResolvedTheme] = useState(() => resolveTheme(mode));
    useEffect(() => {
        const resolved = resolveTheme(mode);
        setResolvedTheme(resolved);
        if (resolved === 'dark') {
            document.documentElement.classList.add('dark');
        }
        else {
            document.documentElement.classList.remove('dark');
        }
        if (mode === 'system') {
            const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
            const handler = (e) => {
                const newTheme = e.matches ? 'dark' : 'light';
                setResolvedTheme(newTheme);
                if (newTheme === 'dark') {
                    document.documentElement.classList.add('dark');
                }
                else {
                    document.documentElement.classList.remove('dark');
                }
            };
            mediaQuery.addEventListener('change', handler);
            return () => mediaQuery.removeEventListener('change', handler);
        }
    }, [mode]);
    return { resolvedTheme };
}
//# sourceMappingURL=use-theme-effect.js.map